import TemplateView from '../TemplateView'
import {reactOnErrorMessage} from './validation/utils'

export default class InputField extends TemplateView {
    constructor({
        placeholder = "",
        type = "text",
        onChange = () => {},
        onBlur = () => {},
        onKeyDown = () => {},
        tabindex = 0,
        value = "",
        additionalClass = "",
        errorMessage = "",
        maxLength = undefined,
        autocomplete = 'off',
        name = '',
        disabled = false,
    }) {
        super()
        this.placeholder = placeholder
        this.additionalClass = additionalClass
        this.type = type
        this.tabindex = tabindex
        this.maxLength = maxLength
        this.state = {
            value,
            errorMessage,
            disabled,
        }
        this.value = value
        this.autocomplete = autocomplete
        this.name = name
        this.onChange = onChange
        this.onBlur = onBlur
        this.onKeyDown = onKeyDown

        this.onStatePropertyChanged("value", value => this.getEl().val(value + ""))
        reactOnErrorMessage(this)
        this.onStatePropertyChanged('disabled', disabled => {
            this.getEl().toggleClass('disabled', disabled)
            this.getEl().attr("disabled", disabled)
        })
    }

    templateHtml() {
        return `
            <input 
                type="<%=type%>" 
                value="<%=value%>" 
                placeholder="<%=placeholder%>"
                class="components_input <%=additionalClass%>" 
                autocomplete="<%=autocomplete%>"
                name="<%=name%>"
                tabindex="<%=tabindex%>"/>`
    }

    afterRender() {
        this.getEl().on('input', () => {
            if (!this.state.disabled) {
                const value = this.getEl().val()
                this.setStateInternal({value})
                this.onChange(value)
            }
        })
        this.getEl().on('blur', () => {
            if (!this.state.disabled) {
                this.onBlur(this.getEl().val())
            }
        })
        this.getEl().keydown((e) => {
            this.onKeyDown(e)
        })

        if (this.maxLength) {
            this.getEl().attr("maxlength", this.maxLength)
        }

        this.renderInitialState()
    }

    getValue() {
        return this.getEl().val()
    }

    setValue(value) {
        this.getEl().val(value)
    }

    focus() {
        this.getEl().focus()
        //for browsers that position the caret at the begin of input
        const caretPosition = this.getValue().length
        this.getEl()[0].setSelectionRange(caretPosition, caretPosition)
    }
}



// WEBPACK FOOTER //
// ./web/js/components/InputField.js